import { render, staticRenderFns } from "./ModalNovaUnimed.vue?vue&type=template&id=e9a5fc54"
import script from "./ModalNovaUnimed.vue?vue&type=script&lang=js"
export * from "./ModalNovaUnimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports